import {Component} from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'rc-tooltip'

import FilterOrder from '../../../../../../shared/components/FilterOrder/FilterOrder.jsx'
import ResultsOffers from '../../../../../../shared/components/FilterBar/components/Results/ResultsOffers.jsx'
import SkillsTreeModal from '../../../../../../shared/components/Modals/SkillsTreeModal/SkillsTreeModal.jsx'
import sitemap from '../../../../../../shared/media/svg/sitemap.svg'

import './OfferSearchTopbar.scss'

export default class OfferSearchTopbar extends Component {
  static propTypes = {
    filters: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool,
    isManager: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    resultsCount: PropTypes.number,
    searchQuery: PropTypes.object.isRequired,
  }

  static defaultProps = {
    isAdmin: false,
    isManager: false,
    resultsCount: 0,
  }

  state = {
    skillsModal: false,
  }

  toggleSkillsModal = () => {
    this.setState((prevState) => ({skillsModal: !prevState.skillsModal}))
  }

  handleOrderChange = (value) => {
    const data = {...value}
    this.props.filters.orders.forEach((item) => {
      if (!(item.name in value)) {
        data[item.name] = null
      }
    })
    this.props.onChange(data)
  }

  render() {
    const {filters, isAdmin, isManager, resultsCount, searchQuery} = this.props
    const showOrders = isAdmin && isManager && filters?.orders?.length > 0

    return (
      <div className="offer-search-topbar">
        <ResultsOffers nb={resultsCount} />

        <div className="offer-search-topbar__right">
          <div className="offer-search-topbar__skills-tree-col">
            <Tooltip placement="bottom" overlay="Arbre de compétences">
              <img className="offer-search-topbar__skills-tree" src={sitemap} alt="Arbre de compétences" onClick={this.toggleSkillsModal} />
            </Tooltip>
          </div>

          {showOrders && (
            <div className="offer-search-topbar__orders">
              {filters.orders.map((item) => (
                <FilterOrder
                  key={item.name}
                  searchQuery={searchQuery}
                  onChange={this.handleOrderChange}
                  name={item.name}
                  label={item.label}
                  tooltip={item.tooltip}
                  className="filter"
                />
              ))}
            </div>
          )}
        </div>

        <SkillsTreeModal
          modal={this.state.skillsModal}
          toggle={this.toggleSkillsModal}
        />
      </div>
    )
  }
}
